import { api } from '@/lib/axios';

export interface ClientCategory {
  id: string;
  name: string;
  description?: string;
  color?: string;
  discount?: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  _count?: {
    clients: number;
  };
}

export interface CreateClientCategoryDto {
  name: string;
  description?: string;
  color?: string;
  discount?: number;
  active?: boolean;
}

export interface UpdateClientCategoryDto {
  name?: string;
  description?: string;
  color?: string;
  discount?: number;
  active?: boolean;
}

export const clientCategoriesService = {
  getAll: async (includeInactive = false): Promise<ClientCategory[]> => {
    const params = new URLSearchParams();
    if (includeInactive) {
      params.append('includeInactive', 'true');
    }

    const { data } = await api.get(`/client-categories?${params.toString()}`);
    return data;
  },

  getOne: async (id: string): Promise<ClientCategory> => {
    const { data } = await api.get(`/client-categories/${id}`);
    return data;
  },

  create: async (dto: CreateClientCategoryDto): Promise<ClientCategory> => {
    const { data } = await api.post('/client-categories', dto);
    return data;
  },

  update: async (id: string, dto: UpdateClientCategoryDto): Promise<ClientCategory> => {
    const { data } = await api.patch(`/client-categories/${id}`, dto);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/client-categories/${id}`);
  },
};
